module.exports = __webpack_public_path__ + "img/leaf.d09663fb.png";